/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

/**
 * Enlarges the draggable / hover area of transform-engine handles without
 * changing the visible handle. The ::before is part of the handle element
 * itself (not a child DOM node), so a pointerdown on it is attributed to the
 * handle and React Flow starts the connection normally.
 *
 * Injected from TS so it doesn't depend on the bundler's CSS-import setup.
 * Height (30px) stays just under the tree's per-entry spacing (~32.8px) so
 * adjacent rows' hit areas never overlap and steal each other's drags.
 */

export const EXPANDED_HANDLE_CLASS = "dexter-expanded-handle";

const STYLE_ELEMENT_ID = "dexter-expanded-handle-style";

if (
  typeof document !== "undefined" &&
  !document.getElementById(STYLE_ELEMENT_ID)
) {
  const style = document.createElement("style");
  style.id = STYLE_ELEMENT_ID;
  style.textContent = `.${EXPANDED_HANDLE_CLASS}::before {
    content: "";
    position: absolute;
    top: 50%;
    right: -4px;
    width: 22px;
    height: 30px;
    transform: translateY(-50%);
    background: transparent;
    pointer-events: all;
  }`;
  document.head.appendChild(style);
}
